import type { TOC } from '@ember/component/template-only';

const ClientsRouteTemplate: TOC<object> = <template>{{outlet}}</template>;

export default ClientsRouteTemplate;
